/* eslint-disable brace-style */
import runtime from 'art-template/lib/runtime';
import OYTool from './components/OYTool';
import OYSideMenu from "./components/OYSideMenu";
import { isArray, isObject, classnames, valueIncludes } from './utils';

if (typeof jQuery === 'undefined') {
  throw new Error('can not find jQuery');
}

//  模板函数绑定
runtime.isArrary = isArray;
runtime.isObject = isObject;
runtime.classnames = classnames;
runtime.styles = OYTool.styles;
runtime.valueIncludes = valueIncludes;
runtime.encode = window.encodeURIComponent;

$.extend({
  OYTool
});

// Jquery插件函数绑定
[
  OYSideMenu
].forEach((Component: any) => {
  $.fn[Component.displayName] = function (option: any) {
    if (!this.length) {
      // return console.error(`${Component.displayName} - Dom not Find`)
      return
    }
    let filterOption: any = { $parent: this };
    filterOption = Object.keys(option).reduce((pre, key) => {
      const value = option[key];
      if (value !== undefined && value !== null) {
        pre[key] = value;
      }
      return pre;
    }, filterOption)
    return new Component(filterOption)
  }
})




// WEBPACK FOOTER //
// ./src/menu.ts